import * as plugins from './lele-serviceworker.plugins';
import { logger } from './serviceworker.logging';

/**
 * MessageManager implements two ways of serviceworker communication
 * * the serviceWorker method
 * * the deesComms method using BroadcastChannel
 */
export class MessageManager {
  public deesComms: plugins.domtools.DomTools['deesComms'];

  /**
   * a typedrouter for reassuring proper communication with the serviceworker using deesComms
   */
  private checkTypedrouter = new plugins.typedrequest.TypedRouter();

  constructor() {
    navigator.serviceWorker.addEventListener('message', (event: MessageEvent) => {
      const response = this.checkTypedrouter.routeAndAddResponse(event.data);
    });
  }

  /**
   * posts a message using serviceworker methods
   * note: this is only used for running backup checks
   * @param postMessageArg
   */
  private async postMessageToServiceworker(postMessageArg: unknown) {
    navigator.serviceWorker.controller.postMessage(postMessageArg);
  }

  /**
   * inits browser ipc communication using deesComms
   */
  public async init () {
    const domtools = await plugins.domtools.DomTools.setupDomTools();
    this.deesComms = domtools.deesComms;

    // lets setup communication with the serviceworker
    this.deesComms.createTypedHandler<plugins.lointServiceworker.IMessage_Serviceworker_Client_UpdateInfo>('serviceworker_newVersion', async req => {
      setTimeout(() => {
        window.location.reload();
      }, 200);
      return {};
    });
  }
}
